import { render, staticRenderFns } from "./deliveryType.vue?vue&type=template&id=0926633c&scoped=true"
import script from "./deliveryType.vue?vue&type=script&lang=js"
export * from "./deliveryType.vue?vue&type=script&lang=js"
import style0 from "./deliveryType.vue?vue&type=style&index=0&id=0926633c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926633c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0926633c')) {
      api.createRecord('0926633c', component.options)
    } else {
      api.reload('0926633c', component.options)
    }
    module.hot.accept("./deliveryType.vue?vue&type=template&id=0926633c&scoped=true", function () {
      api.rerender('0926633c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/InternalDelivery/deliveryType/deliveryType.vue"
export default component.exports